export default class UserData {
    constructor(
        private userFirstName: string,
        private userLastName: string,
        private subscriberId: number,
        private userSessionId: string,
        private userChatSessionId: string,
        private salutation: string,
        private botChatSessionId: string,
    ) {
    }

    public getUserFirstName(): string
    {
        return this.userFirstName;
    }

    public getUserLastName(): string
    {
        return this.userLastName;
    }

    public getSubscriberId(): number
    {
        return this.subscriberId;
    }

    public getUserSessionId(): string
    {
        return this.userSessionId;
    }

    public setUserSessionId(userSessionId: string): void
    {
        this.userSessionId = userSessionId;
    }

    public getBotChatSessionId(): string
    {
        return this.botChatSessionId;
    }

    public setBotChatSessionId(chatId: string): void
    {
        this.botChatSessionId = chatId;
    }

    public getUserChatSessionId(): string {
        return this.userChatSessionId;
    }

    public setUserChatSessionId(value: string) {
        this.userChatSessionId = value;
    }
}